import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, deepClone } from '../utils'
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import BlockIcon from '@mui/icons-material/Block';
import Loading from './Loading';
import { useDispatch, useSelector } from 'react-redux';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { redNex } from '../Redux/nexSlice';


function CrawlabilityTest({ nexListn, _nex }) {
    const [data, setData] = useState([])
    const [url, setUrl] = useState('')
    const [page, setPage] = useState('')

    const [isLoading, setIsLoading] = useState(false)

    const [noInput1, setNoInput1] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)


    const dispatch = useDispatch()


    useEffect(()=> {
        if(page !== '') {
            setPage('')
            setData([])
        }
    }, [url])

    const getData = async () => {
        if(url !== '') {
          setNoInput1(false)

          const updateAnalytics = async () => {
            const tool = window.location.pathname.split('/').pop();
            let tools = deepClone(user.analytics.toolsUsage);
        
            if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
                tools[tool] = 1;
            } else {
                tools[tool] = Number(tools[tool]) + 1;
            }
        
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };

            setIsLoading(true)
            fetch(`${base}/res`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'ct',
                url: url,
                userId: user.id
              })
            }).then(res=> res.json()).then(data=> {
              setData(data)
              setIsLoading(false)
              dispatch(redNex(nx))
              updateAnalytics()
            })
          } else {
            if(url.trim() === '') setNoInput1(true)
          }
    }

    const getPageTest = async () => {
        if(url !== '' && page !=='') {
            setIsLoading(true)
            fetch(`${base}/res`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'ct',
                url: `${url}/${page}`
              })
            }).then(res=> res.json()).then(data=> {
              setData(data)
              setIsLoading(false)
            })
          }
    }

   


  return (
    <CrawlabilityTestContainer>
            <CrawlabilityTestInputContainer>
            <h2>Crawlability Test<span style={{fontSize: 'medium'}}></span></h2>
            <CrawlabilityTestInputInnerContainer page={page}>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Your Website or Webpage</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': '', color: '#1eb277'}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                {/* {data.length !== 0 && data[0].url !== 'N/A' && <div style={{position: 'relative', marginBottom: '20px'}}><span style={{marginLeft: '50px', color: 'gray'}}>{`${url}/`}</span><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '245px', top: '20%', fontSize: 'small'}}>Test Another Page</label><input type='text' className='page-input' style={{marginLeft: '20px'}} value={page} onChange={e=> setPage(e.target.value)}/></div>} */}
                {page === '' && 
                <>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Run Test': 'Running Test ...'}</button>}
                {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
                </>
                }
                {page !== '' && <button onClick={getPageTest}>Test this page!</button>}
            </CrawlabilityTestInputInnerContainer>
        </CrawlabilityTestInputContainer>

        {data.length !== 0 && data[0].url !== 'N/A' && !isLoading && <CrawlabilityTestResContainer>
            <TestRes>
                <div><p>URL</p></div>
                <div>
                    <p>Rule</p>
                </div>
                <div>
                    <p>Crawlable?</p>
                </div>
                <div>
                    <p>Indexable?</p>
                </div>
            </TestRes>
            {data.length !== 0 && 
            <TestRes>
                <div><p>{data[0].url}</p></div>
                <div>
                    <p><span style={{fontWeight: '400', marginRight: '15px'}}>Google Crawl Rule: </span>{data[0].info.googleCrawlRule}</p>
                    <p><span style={{fontWeight: '400', marginRight: '15px'}}>Bing Crawl Rule: </span>{data[0].info.bingCrawlRule}</p>
                    <p><span style={{fontWeight: '400', marginRight: '15px'}}>Google Index Rule: </span>{data[0].info.googleIndexRule}</p>
                    <p><span style={{fontWeight: '400', marginRight: '15px'}}>Bing Index Rule: </span>{data[0].info.bingIndexRule}</p>
                </div>
                <div>
                    <p>{data[0].indexable.google?.match(/([^/]+)(?=\.\w+$)/)[1] === 'check32'? <CheckBoxIcon style={{color: 'var(--tst-color)'}}/>: <DisabledByDefaultIcon style={{color: 'red'}}/>}<span>Google</span></p>
                    <p>{data[0].indexable.bing?.match(/([^/]+)(?=\.\w+$)/)[1] === 'check32'? <CheckBoxIcon style={{color: 'var(--tst-color)'}}/>: <DisabledByDefaultIcon style={{color: 'red'}} />}<span>Bing</span></p>
                </div>
                <div>
                    <p>{data[0].crawlable.google?.match(/([^/]+)(?=\.\w+$)/)[1] === 'check32'? <CheckBoxIcon style={{color: 'var(--tst-color)'}}/>: <DisabledByDefaultIcon style={{color: 'red'}} />}<span>Google</span></p>
                    <p>{data[0].crawlable.bing?.match(/([^/]+)(?=\.\w+$)/)[1] === 'check32'? <CheckBoxIcon style={{color: 'var(--tst-color)'}}/>: <DisabledByDefaultIcon style={{color: 'red'}} />}<span>Bing</span></p>
                </div>
            </TestRes>}
        </CrawlabilityTestResContainer>}
        {data.length !== 0 && data[0].url === 'N/A' && !isLoading && 
        <CrawlabilityTestResContainer>
            <NoConnection>
                <BlockIcon style={{color: 'var(--tst-color)', fontSize: '70px', marginBottom: '30px'}} />
                <p>We couldn't connect to <span>{url}</span></p>
            </NoConnection>
        </CrawlabilityTestResContainer>}
        {isLoading && <Loading />}

        {data.length == 0 && !isLoading && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The Crawlability Test Tool analyzes your website to identify issues that might prevent search engines from crawling and indexing your content effectively. 
            By ensuring your site is easily crawlable, you can improve its visibility in search results and enhance overall SEO performance.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter your website URL in the search bar</p>
          <p>2. Click "Run Test" to analyze your site’s crawlability</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Regularly perform crawlability tests to identify and resolve issues that could hinder search engine crawling and indexing</p>

        </Intro>}
    </CrawlabilityTestContainer>
  )
}

export default CrawlabilityTest


const CrawlabilityTestContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const CrawlabilityTestInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--tst-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--tst-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--tst-color);
    color: white;
  }

  > div > button:hover {
    color: var(--tst-color);
    background-color: rgb(239, 239, 239);
  }
`


const CrawlabilityTestInputInnerContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--tst-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }


  .page-input {
    outline: none;
    border-radius: 2px;
    width: 300px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--tst-color);
    padding-left: 10px;
    font-size: medium;
  }

  > div > .input-btn {
    position: absolute;
    transform: translateY(10%);
    left: auto;
    top: 20%;
    width: 150px;
    border: none;
    padding: 5px 10px;
    cursor: ${props=> props.page === ''? 'not-allowed': 'pointer'};
    background-color: ${props => props.page === '' ? 'rgb(230, 230, 230)' : 'var(--tst-color)'};
    color: ${props=> props.page === ''? 'gray': 'white'};
  }

  > div > .input-btn:hover {
    color: ${props=> props.page === ''? 'gray': 'var(--tst-color)'};
    background-color: ${props => props.page === '' ? 'rgb(230, 230, 230)' : 'rgb(239, 239, 239)'};
  }
`


const CrawlabilityTestResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;
`


const TestRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);


    > div {
        display: flex;
        flex-direction: column;
        width: 700px;
        margin-left: 30px;
        margin-right: 20px;
        width: 300px;
    }

    > div > p {
        display: flex;
        align-items: center;
    }
`


const NoConnection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-block: 60px;
    background: repeating-linear-gradient(-45deg, var(--tst-color), #00800027 33.33%, #ffffff 33.33%, #ffffff 66.66%);


    > p {
        font-size: large;
        color: var(--tst-color);
    }

    > p > span {
        color: gray;
    }
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`